/* 
 * Développé par la société Précurseur.
 @copyright  Copyright (c) Précurseur
 @link       https://www.precurseur.fr
 */
import $ from 'jquery';

/**
 * Sticky scrollbar sidebar news extranet
 */
export default class AdherentDirectoryFilterRegion {

    constructor() {

        this.countrySelector = $('#seila_adh_country');
        this.regionSelector = $('#seila_adh_region');

        if (this.countrySelector.length) { 
            this.init();
        }
    }

    init() {
        var that = this;
        this.countrySelector.on('change', function() {

            var valueSelected = this.value;
            
            const ajaxurl = $(this).attr('data-url');
            const action = $(this).attr('data-action');
            
            // Les données de notre formulaire
            const data = 'seila_adh_country=' + valueSelected + '&action=' + action;
            that.refresh(ajaxurl, action, data);
        })
    }
    
    refresh(ajaxurl, action, data) {
        
        var that = this;
        // Requête Ajax en JS natif via Fetch
        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
        })
        .then(response => response.json())
        .then(body => {
            
            that.regionSelector.find('option').remove();               
            that.regionSelector.append($('<option>', {
                value: '',
                text: 'Toutes les régions'
            }));
            
            if (body.data.length) {
                $.each(body.data, function( index, value ) {
                  that.regionSelector.append($('<option>', {
                        value: value.id,
                        text: value.name
                    }));
                });
            }
        });
    }
};
